import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import DeviceProvider from "./context/deviceProvider";
import UserProvider, { UserContext } from "./context/userProvider";
import HomepageProvider from "./context/homepageProvider";
import MaintenanceProvider from "./context/maintenanceProvider";
import DevicesStatus from "./screens/deviceStatus/devicesStatus";
import LoginPage from "./screens/login/loginPage";
import Homepage from "./screens/homepage/homepage";
import DeviceStatusByStatus from "./screens/deviceStatus/deviceStatusByStatus";
import MaintenanceList from "./screens/maintenance/maintenanceList";
import NewMaintenance from "./screens/maintenance/newMaintenance";
import MaintenanceDetail from "./screens/maintenance/maintenanceDetail";
import SaReceiveList from "./screens/saReceive/saReceiveList";
import SaReceiveDetail from "./screens/saReceive/saReceiveDetail";
import PendingList from "./screens/maintenancePending/pendingList";
import PendingOrderDetail from "./screens/maintenancePending/pendingOrderDetail";
import RecordList from "./screens/maintenanceRecord/recordList";
import MaintenanceRecordDetail from "./screens/maintenanceRecord/maintenanceRecordDetail";
import MaintenanceReportPDF from "./screens/maintenanceRecord/maintenanceReportPDF";
import CustomerList from "./screens/customers/customerList";
import CustomerDetail from "./screens/customers/customerDetail";
import PairDevice from "./screens/deviceData/pairDevice";
import MachineProfile from "./screens/deviceData/machineProfile";
import RealtimeDevice from "./screens/deviceData/realtimeDevice"
import IotNumber from "./screens/deviceStructure/iotNumber";
import DeviceNumber from "./screens/deviceStructure/deviceNumber";
import DeviceModel from "./screens/deviceStructure/deviceModel";
import DeviceParts from "./screens/deviceStructure/deviceParts";
import CompanyDetail from "./screens/setting/companyDetail";
import UserList from "./screens/setting/users/userList";

export default class App extends Component {
  render() {
    return (
      <DeviceProvider>
        <MaintenanceProvider>
          <UserProvider>
            <HomepageProvider>
              <BrowserRouter>
                <Routes>
                  {/* //? Login } */}
                  <Route path="/" element={<LoginPage />} />
                  <Route path="/home" element={<Homepage />} />

                  {/* //?Devices Status */}
                  <Route path="/device-status" element={<DevicesStatus />} />
                  <Route path="/device-status/:id" element={<DeviceStatusByStatus />} />

                  {/* //? Maintenance */}
                  <Route path="/maintenance-list" element={<MaintenanceList />} />
                  <Route path="/maintenance-list/new-maintenance" element={<NewMaintenance />}/>
                  <Route path="/maintenance-list/:id" element={<MaintenanceDetail />} />

                  {/* //? SA Receive */}
                  <Route path="/sa-receive-list" element={<SaReceiveList />} />
                  <Route path="/sa-received/:id" element={<SaReceiveDetail />} />

                  {/* //? Maintenance Pending */}
                  <Route path="/pending-list" element={<PendingList />} />
                  <Route path="/pending/:id" element={<PendingOrderDetail />} />

                  {/* //? Maintenance Record */}
                  <Route path="/record-list" element={<RecordList />} />
                  <Route path="/record/:id" element={<MaintenanceRecordDetail />} />
                  <Route path="/report/:id" element={<MaintenanceReportPDF />} />

                  {/* //? Customers */}
                  <Route path="/customers-list" element={<CustomerList />} />
                  <Route path="/customers/:id" element={<CustomerDetail />} />

                  {/* //? Device Data */}
                  <Route path="/pair-device-list" element={<PairDevice />} />
                  <Route path="/machine-list" element={<MachineProfile />} />
                  <Route path="/realtime-device/:id" element={<RealtimeDevice />} />

                  {/* //? Device Structure */}
                  <Route path="/iot-number" element={<IotNumber />} />
                  <Route path="/device-number" element={<DeviceNumber />} />
                  <Route path="/device-model" element={<DeviceModel />} />
                  <Route path="/device-parts" element={<DeviceParts />} />

                  {/* //? Setting */}
                  <Route path="/setting/company" element={<CompanyDetail />} />
                  <Route path="/setting/users" element={<UserList />} />

                </Routes>
              </BrowserRouter>
            </HomepageProvider>
          </UserProvider>
        </MaintenanceProvider>
      </DeviceProvider>
    );
  }
}

// App.contextType = UserContext;
